<template>
  <v-form ref="productEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({ name: 'product-index' })">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{ this.id ? "Редактирование блюда" : "Создание блюда" }}</h1>
      </v-col>
      <v-col>
        <v-tabs v-model="tab">
          <v-tab>Описание</v-tab>
          <v-tab :disabled="!this.product || !this.product.id">Состав</v-tab>
          <v-tab :disabled="!this.product || !this.product.id">SEO</v-tab>
          <v-tab :disabled="!this.product || !this.product.id">Фотографии</v-tab>
          <v-tab :disabled="!this.product || !this.product.id">Быстрый выбор</v-tab>
          <v-tab :disabled="!this.product || !this.product.id">Рецепты</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pt-5">
          <v-tab-item :eager="true">
            <v-row>
              <v-col cols="12" sm="5" md="4" xl="3">
                <v-tabs v-model="tabLang">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabLang">
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field v-model="product.name" label="Название блюда" :rules="[rules.required]" required
                                      outlined></v-text-field>
                        <v-textarea label="Описание" :rules="[rules.required]" required v-model="product.description"
                                    rows="5" outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field v-model="product.name_ua" label="Название блюда" :rules="[rules.required]"
                                      required outlined></v-text-field>
                        <v-textarea label="Описание" :rules="[rules.required]" required v-model="product.description_ua"
                                    rows="5" outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>

                <v-select :items="timerOptions" :item-text="(timerOption) => timerOption.text"
                          :item-value="(timerOption) => timerOption.val" v-model="product.timer" label="Таймер"
                          outlined append-icon="mdi-timer-outline">

                </v-select>
                <!--                  <v-combobox :items="timerOptions" placeholder="0:00" :item-text="(timerOption) => timerOption.text"-->
                <!--                              :item-value="(timerOption) => timerOption.val" return-object-->
                <!--                              v-model="product.timer" outlined append-icon="mdi-timer-outline" solo>-->
                <!--                  </v-combobox>-->


                <v-text-field v-model="product.iiko_id" label="Iiko ID" outlined/>
                <v-text-field v-model="product.np_code" label="Новая Почта Артикул" outlined/>
                <v-text-field v-model="product.np_iiko_id" label="Новая Почта Iiko ID" outlined/>
                <v-select :items="categories" :item-text="(category) => category.name"
                          :item-value="(category) => category.id" v-model="product.parentCategory" label="Категория"
                          outlined
                          :rules="[rules.required]" required return-object
                          @change="updateChildrenCategories"></v-select>
                <v-select :items="childrenCategories" :item-text="(category) => category.name"
                          :item-value="(category) => category.id" v-model="product.category" label="Подкатегория"
                          :disabled="childrenCategories.length === 0" outlined return-object></v-select>
                <v-select :items="workshops" :item-text="(workshop) => workshop.name"
                          :item-value="(workshop) => workshop" v-model="product.workshop" label="Цех" outlined
                          :rules="rules.requiredSelect" required></v-select>
                <v-select :items="tags" :item-text="(tag) => tag.name" :item-value="(tag) => tag.id"
                          v-model="product.tags" label="Теги" chips multiple outlined></v-select>
                <v-text-field v-model="product.np_size" :rules="[rules.required]" required label="Размер для НП"
                              outlined></v-text-field>
                <v-row>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field v-model="product.price" :rules="[rules.required]" required label="Цена" suffix="UAH"
                                  outlined></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field v-model="product.weight" label="Вес" :rules="[rules.required]" required suffix="g"
                                  outlined></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field v-model="product.energy_amount" label="Калории" :rules="[rules.required]" required outlined></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field v-model="product.fiber_amount" label="Белки" :rules="[rules.required]" required
                                  suffix="g" outlined></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field v-model="product.fat_amount" label="Жиры" :rules="[rules.required]" required
                                  suffix="g" outlined></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field v-model="product.carbohydrate_amount" label="Углеводы" :rules="[rules.required]"
                                  required suffix="g" outlined></v-text-field>
                  </v-col>
                </v-row>
                <v-checkbox v-model="product.hide" label="Скрыть блюдо"></v-checkbox>
                <v-checkbox
                    v-model="product.is_not_cashback"
                    label="Не начислять кэшбек с этого блюда"
                ></v-checkbox>
                <v-checkbox
                    v-model="product.is_disabled_delivery"
                    label="Выключить доставку НП для этого блюда"
                ></v-checkbox>
                <v-btn :loading="loadingButton" @click="save">{{ id ? 'Сохранить' : 'Создать'}}</v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>V
              <v-col cols="12" class="pt-0">
                <div class="top" v-if="modifiers.length > 0">
                  <modifiers-modal :product-id="product.id" :modifier-categories="modifiers" v-model="product">
                  </modifiers-modal>
                </div>
                <div class="list mt-4">
                  <product-modifiers-table v-model="product" :loading="loading"></product-modifiers-table>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col cols="12" sm="5" md="4" xl="3">
                <v-tabs v-model="tabLang">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabLang">
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field v-model="product.seo_h1" label="SEO H1" outlined></v-text-field>
                        <v-text-field v-model="product.seo_title" label="SEO Заголовок" outlined></v-text-field>
                        <v-textarea v-model="product.seo_description" label="SEO Описание" outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field v-model="product.seo_h1_ua" label="SEO H1" outlined></v-text-field>
                        <v-text-field v-model="product.seo_title_ua" label="SEO Заголовок" outlined></v-text-field>
                        <v-textarea v-model="product.seo_description_ua" label="SEO Описание" outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-btn :loading="loadingButton" @click="save">{{ id ? 'Сохранить' : 'Создать'}}</v-btn>
          </v-tab-item>
          <v-tab-item>
            <v-row class="product-images">
              <v-col cols="12" sm="4">
                <div class="mb-8">
                  <v-img :src="previewImage(false, backgroundImage)" aspect-ratio="1.6">
                    <template v-slot:placeholder>
                      <div class="image-placeholder"></div>
                    </template>
                  </v-img>
                </div>
                <div style="width: 264px; max-width: 100%;">
                  <v-file-input label="Фон в карточку блюда" prepend-icon="" outlined class="cursor-pointer"
                                v-model="backgroundImage">
                  </v-file-input>
                </div>
              </v-col>
              <v-col cols="12" sm="1" class="text-center d-none-xs">
                <v-divider vertical></v-divider>
              </v-col>
              <v-col cols="12" sm="3">
                <div class="mb-8">
                  <v-img :src="previewImage(true, listImage)" aspect-ratio="1">
                    <template v-slot:placeholder>
                      <div class="image-placeholder"></div>
                    </template>
                  </v-img>
                </div>
                <div style="width: 264px; max-width: 100%;">
                  <v-file-input label="Картинка в список блюд" prepend-icon="" outlined class="cursor-pointer"
                                v-model="listImage">
                  </v-file-input>
                </div>
              </v-col>
              <v-col cols="12">
                <v-btn :loading="loadingButton" v-if="id" @click="updateImages">Сохранить</v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" sm="12">
                <modifiers-group-modal v-model="product"></modifiers-group-modal>
                <modifiers-group-table v-model="product.modifiers_group" :disabled="true" :loading="loading">
                </modifiers-group-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col cols="12" sm="5" md="4" xl="3">
                <v-tabs v-model="tabLang">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-tabs-items class="w-100" v-model="tabLang">
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col cols="12">
                        <b>Простой</b>
                        <v-textarea label="Рецепт" class="w-50" v-model="product.recipe_simple" rows="5" outlined
                                    placeholder="1.Разогреть духовку до 180 градусов.
2.Выложить котлеты на противень. Налить 100 мл воды.
3.Поставить в духовку на 15 минут.">
                        </v-textarea>
                        <b>Обычный</b>
                        <v-textarea label="Рецепт" class="w-50" v-model="product.recipe_usual" rows="5" outlined
                                    placeholder="1.Разогреть духовку до 180 градусов.
2.Выложить котлеты на противень. Налить 100 мл воды.
3.Поставить в духовку на 15 минут.">
                        </v-textarea>
                        <b>Гурман</b>
                        <v-textarea label="Рецепт" class="w-50" v-model="product.recipe_gurman" rows="5" outlined
                                    placeholder="1.Разогреть духовку до 180 градусов.
2.Выложить котлеты на противень. Налить 100 мл воды.
3.Поставить в духовку на 15 минут.">
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item>
                    <v-row>
                      <v-col cols="12">
                        <b>Простий</b>
                        <v-textarea label="Рецепт" v-model="product.recipe_simple_ua" rows="5" outlined placeholder="1.Розігріти духовку до 180 градусів.
2.Викласти котлети на лист. Налити 100мл води.
3.Поставити в духовку на 15 хвилин."></v-textarea>
                        <b>Звичайний</b>
                        <v-textarea label="Рецепт" v-model="product.recipe_usual_ua" rows="5" outlined placeholder="1.Розігріти духовку до 180 градусів.
2.Викласти котлети на лист. Налити 100мл води.
3.Поставити в духовку на 15 хвилин."></v-textarea>
                        <b>Гурман</b>
                        <v-textarea label="Рецепт" v-model="product.recipe_gurman_ua" rows="5" outlined placeholder="1.Розігріти духовку до 180 градусів.
2.Викласти котлети на лист. Налити 100мл води.
3.Поставити в духовку на 15 хвилин."></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-btn :loading="loadingButton" @click="save">{{ id ? 'Сохранить' : 'Создать'}}</v-btn>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackbarColor" right top>
      {{ snackbarText }}
    </v-snackbar>
  </v-form>
</template>

<script>
// @ is an alias to /src
import ProductService from "./../../api/ProductService";
import CategoryService from "./../../api/CategoryService";
import TagService from "./../../api/TagService";
import WorkshopService from "./../../api/WorkshopService";
import ModifierService from "../../api/ModifierService";
import ModifiersModal from "../../components/ModifiersModal";
import ModifiersGroupModal from "../../components/ModifiersGroupModal";
import ProductModifiersTable from "../../components/ProductModifiersTable";
import ModifiersGroupTable from "../../components/ModifiersGroupTable";


export default {
  name: "ProductEdit",
  props: {
    id: {
      default: null,
    },
  },
  components: {
    ModifiersModal,
    ProductModifiersTable,
    ModifiersGroupTable,
    ModifiersGroupModal,
  },
  data: () => ({
    snackbar: false,
    timeout: 2000,
    snackbarText: "",
    childrenCategories: [],
    snackbarColor: "",
    tab: "",
    tabLang: "",
    rules: {
      required: (value) => !!value || "Нужно заполнить",
      requiredSelect: [(v) => !!v.id || "Нужно заполнить"],
    },
    sauces: [],
    valid: true,
    product: {
      name: "",
      name_ua: "",
      description: "",
      description_ua: "",
      np_code: "",
      np_iiko_id: "",
      category: "",
      timer: 0,
      energy_amount: "",
      fiber_amount: "",
      fat_amount: "",
      np_size: 0,
      carbohydrate_amount: "",
      weight: "",
      price: "",
      workshop: "",
      is_not_cashback: false,
      is_disabled_delivery: false,
      tags: "",
      hide: false,
      recipe_simple: "",
      recipe_usual: "",
      recipe_gurman: "",
      parentCategory: {
        children: [],
      },
    },
    listImage: null,
    backgroundImage: null,
    loading: true,
    modifiersDialog: false,
    modifierCategories: [],
    modifierTab: null,
    searchModifiers: "",
    modifiers: [],
    loadingButton: false,
    categories: [],
    tags: [],
    workshops: [],
    modifiersGroup: [],
    modal_from: false,
    modal_to: false,
  }),
  computed: {

    timerOptions() {
      let timerOptions = [];
      let mins = 0;

      for (let i = 0; i < 120; i += 5) {
          if (i >= 60 && i <= 115) mins += 5;
          timerOptions.push({
            text: (i == 0) ? `0:00` :
                (i == 5) ? `0:05` :
                (i == 115) ? `2:00` :
                    (i == 60) ? `1:0${mins}` :
                        (i > 60) ? `1:${mins}` :
                            `0:${i}`,
            val: i
          })
      }

      return timerOptions

    }
  },
  async mounted() {
    try {
      const [
        categoriesResponse,
        modifierCategoriesResponse,
        modifiersGroupResponse,
        modifiersResponse,
        workshopsResponse,
        tagsResponse,
      ] = await Promise.all([
        CategoryService.list(),
        ModifierService.getCategoryList(),
        ModifierService.listGroups(),
        ModifierService.listByCategory(),
        WorkshopService.list(),
        TagService.list(),
      ]);

      this.categories = categoriesResponse.data;
      this.modifierCategories = modifierCategoriesResponse.data;
      this.modifiersGroup = modifiersGroupResponse.data;
      this.modifiers = modifiersResponse.data;
      this.workshops = workshopsResponse.data;
      this.tags = tagsResponse.data;

      this.init();
    } catch (error) {
      console.error("Error loading data:", error);
    }
  },
  methods: {
    updateChildrenCategories() {
      if (this.categories.length > 0) {
        const parentCategory = this.categories.find(
            (category) => category.id === this.product.parentCategory.id
        );
        if (parentCategory) {
          this.childrenCategories = parentCategory.children;
        }
      }
    },

    validate() {
      this.$refs.productEditForm.validate();

      if (this.product.name === "" && this.product.name_ua !== "") {
        this.tabLang = 0;
      } else if (this.product.name !== "" && this.product.name_ua === "") {
        this.tabLang = 1;
      }
    },
    init() {
      if (this.id) {
        ProductService.get(this.id).then((response) => {
          this.product = response.data;

          this.setImages();
          this.updateCategories(response.data.category);

          this.product = this.formatProductFields(this.product);

          this.product.tags = this.product.tags.map(tag => tag.id);

          this.serviceCategory();
          this.loading = false;
        });
      }
    },
    setImages() {
      if (this.product.main_image) {
        this.listImage = { ...this.product.main_image, name: this.product.main_image.file };
      }
      if (this.product.background_image) {
        this.backgroundImage = { ...this.product.background_image, name: this.product.background_image.file };
      }
    },
    updateCategories(category) {
      if (this.categories.length > 0) {
        const parentCategory = this.categories.find(
            (categoryItem) => categoryItem.id === category.parent_group
        );
        if (parentCategory) {
          this.childrenCategories = parentCategory.children;
        }
      }
    },
    formatProductFields(product) {
      const fieldsToCheck = [
        "price",
        "energy_amount",
        "fiber_amount",
        "fat_amount",
        "carbohydrate_amount",
        "weight"
      ];

      fieldsToCheck.forEach(field => {
        product[field] = product[field] === 0 ? "" : product[field];
      });

      return product;
    },
    serviceCategory() {
      const category = this.product.category;

      if (category && category.parent && category.parent_group !== this.product.parentCategory.id) {
        this.product.category = null;
      }

      if (category) {
        this.product.parentCategory = category.parent || category;
        this.product.category = this.product.parentCategory === category ? null : category;
      }
    },
    previewImage(isList, image) {
      if (isList && this.listImage?.url) {
        return this.listImage.url;
      } else if (!isList && this.backgroundImage?.url) {
        return this.backgroundImage.url;
      }
      return image ? URL.createObjectURL(image) : null;
    },
    updateImages() {
      this.loadingButton = true;
      const formData = this.getDataImage();

      ProductService.update(this.product.id, formData)
          .then(() => {
            this.showSnackbar("Блюдо успешно обновлено", "success");
          })
          .catch(() => {
            this.showSnackbar("Ошибка при обновлении блюда", "error");
          })
          .finally(() => {
            this.loadingButton = false;
          });
    },
    async save() {
      this.validate();
      if (!this.valid) return false;

      this.loadingButton = true;
      const formData = this.getData();

      try {
        let response;

        // Check if we're updating or creating based on whether there's an ID
        if (this.product.id) {
          response = await ProductService.update(this.product.id, formData);
          this.product.np_iiko_id = response.data.np_iiko_id
          this.showSnackbar("Блюдо успешно обновлено", "success");
        } else {
          response = await ProductService.create(formData);
          this.product = response.data;
          this.serviceCategory();
          this.init();
          this.$router.push({ name: "product-edit", params: { id: response.data.id } });
          this.showSnackbar("Блюдо успешно создано", "success");
        }
      } catch (error) {
        this.showSnackbar(this.product.id ? "Ошибка при обновлении блюда" : "Ошибка при создании блюда", "error");
      } finally {
        this.loadingButton = false;
      }
    },
    showSnackbar(message, color) {
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    getDataImage() {
      const formData = new FormData();
      formData.append("isUpdateImage", 1);

      if (this.id) {
        if (this.listImage && !this.listImage.url) {
          formData.append("listImage", this.listImage);
        } else if (this.listImage?.url) {
          formData.append("listImage", this.listImage.url);
        }

        if (this.backgroundImage && !this.backgroundImage.url) {
          formData.append("backgroundImage", this.backgroundImage);
        } else if (this.backgroundImage?.url) {
          formData.append("backgroundImage", this.backgroundImage.url);
        }
      }

      return formData;
    },
    getData() {
      const formData = new FormData();

      const categoryId = this.product.category
          ? this.product.category.id
          : this.product.parentCategory
              ? this.product.parentCategory.id
              : null;

      formData.append("name", this.product.name);
      formData.append("name_ua", this.product.name_ua);
      formData.append("description_ua", this.product.description_ua);
      formData.append("description", this.product.description);
      formData.append("seo_h1", this.product.seo_h1);
      formData.append("seo_h1_ua", this.product.seo_h1_ua);
      formData.append("seo_title", this.product.seo_title);
      formData.append("seo_title_ua", this.product.seo_title_ua);
      formData.append("seo_description", this.product.seo_description);
      formData.append("seo_description_ua", this.product.seo_description_ua);
      formData.append("timer", this.product.timer || 0);
      formData.append("is_not_cashback", this.product.is_not_cashback ? 1 : 0);
      formData.append("is_disabled_delivery", this.product.is_disabled_delivery ? 1 : 0);
      formData.append("iiko_id", this.product.iiko_id);
      formData.append("np_code", this.product.np_code);
      formData.append("np_iiko_id", this.product.np_iiko_id);
      formData.append("np_size", this.product.np_size);
      formData.append("parent_group", categoryId);
      formData.append("workshop_id", this.product.workshop?.id || this.product.workshop || null);
      formData.append("tags", this.product.tags);
      formData.append("hide", this.product.hide ? 1 : 0);
      formData.append("energy_amount", this.product.energy_amount);
      formData.append("fiber_amount", this.product.fiber_amount);
      formData.append("fat_amount", this.product.fat_amount);
      formData.append("carbohydrate_amount", this.product.carbohydrate_amount);
      formData.append("weight", this.product.weight);
      formData.append("price", this.product.price);
      formData.append("recipe_simple", this.product.recipe_simple);
      formData.append("recipe_usual", this.product.recipe_usual);
      formData.append("recipe_gurman", this.product.recipe_gurman);
      formData.append("recipe_simple_ua", this.product.recipe_simple_ua);
      formData.append("recipe_usual_ua", this.product.recipe_usual_ua);
      formData.append("recipe_gurman_ua", this.product.recipe_gurman_ua);

      return formData;
    }
  }

};
</script>
<style lang="scss">
.cursor-pointer:hover {
  .v-input__control {
    .v-input__slot {
      cursor: pointer !important;
    }
  }
}
</style>

<style scoped lang="scss">
.image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #f3f7fc;
  border-radius: 4px;
}

.product-images .v-image {
  max-height: 374px;
}

.modifier {
  position: relative;

  &:before {
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #f8fbff;
    border-right-style: 3px;

    .img {
      height: 3.541vw;
      text-align: center;
      margin-top: 0.83vw;

      .v-img {
        margin: 0 auto;
      }
    }

    .name {
      margin-top: 0.72vw;
      text-align: center;
      color: #8c959d;
    }
  }
}

.w-100 {
  width: 100%;
}
</style>
